import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../../shared/models/component-messages/mapaAN/step3';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';

@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html'
})
export class Step3Component implements OnInit {

  private LOG: LogService = new LogService(Step3Component);

	@Input() annulation: String;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() uid = '';
  @Input() linkForRouter: string;

  constructor(
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
  ) {
  }

  ngOnInit(): void {
  }

  public step3 = new Step3();

  getUid(){
    return this.uid;
  }
}
